<template>
    <card-dashboard 
        bg-variante="danger" 
        titulo="" 
        titulo-modal="Contratos"
    >
        <template #titulo>
            <span>
                Contratos
            </span>
        </template>
        <template #valor>
            <div class="row">
                <div class="col-6 text-center border-right border-white">
                    <b-badge variant="light">Ativos</b-badge>
                    <div class="font-weight-bold text-center font-size-20 mb-3 text-white">
                        {{totalAtivos()}}
                    </div>
                </div>
                <div class="col-6 text-center border-left border-white">
                    <b-badge variant="light">Encerrados</b-badge>
                    <div class="font-weight-bold text-center font-size-20 mb-3 text-white">
                        {{totalEncerrados()}}
                    </div>
                </div>
            </div>
        </template>
    </card-dashboard>
</template>
<script>
import CardDashboard from "@/components/card/CardDashboard";
import DashboardAdminService from "@/common/services/dashboards/dashboard_admin.service";
export default {
    components : {
        CardDashboard
    },
    mounted(){
        this.buscarDados();
    },
    data : () => ({
        dados : null,
    }),
    methods : {
        buscarDados(){
            DashboardAdminService.contratos().then(response => {
                this.dados = response.data.data;
            });
        },
        totalAtivos(){
            if (this.dados && this.dados.ativos)
                return this.dados.ativos.length;
        },
        totalEncerrados(){
            if (this.dados && this.dados.encerrados)
                return this.dados.encerrados.length;
        }
    }
}
</script>
<style lang="">
    
</style>